var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.33667,
    y: 0.46521,
    width: 63.8084,
    height: 63.8084,
    rx: 6.96092,
    fill: "#0B163F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1167 31.3679L18.4519 25.6464C17.7154 24.9666 17.7154 23.8337 18.4519 23.0972L23.5502 18.0556C24.23 17.3191 25.3629 17.3191 26.0427 18.0556L27.9688 19.925L24.4566 23.4371C24.2866 23.6071 24.2866 23.8903 24.4566 24.0603L25.1363 24.74C25.193 24.7967 25.3063 24.8533 25.4196 24.8533C25.5329 24.8533 25.6462 24.7967 25.7595 24.74L29.215 21.2279L31.7642 23.7204L24.1167 31.3679ZM46.0961 24.74L43.4903 27.3459L37.0891 20.9446L39.6949 18.3388C40.7712 17.2625 42.4707 17.2625 43.547 18.3388L46.0961 20.888C47.1725 21.9643 47.1725 23.6637 46.0961 24.74ZM35.8428 22.1909L42.2441 28.5921L25.4196 45.4166L19.3016 46.4929C18.5085 46.6629 17.7721 45.9264 17.942 45.1334L19.0184 39.0154L35.8428 22.1909ZM46.3794 38.3922C47.1158 39.072 47.1158 40.205 46.3794 40.8847L41.3377 45.9831C40.6013 46.7195 39.4683 46.7195 38.7885 45.9831L33.0671 40.3183L40.7146 32.6708L43.2071 35.2199L39.6949 38.6755C39.525 38.8454 39.525 39.1287 39.6949 39.2986L40.3747 39.9784C40.5446 40.1483 40.8279 40.1483 40.9978 39.9784L44.51 36.4662L46.3794 38.3922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon3);
export default __webpack_public_path__ + "static/media/Home_icon3.5dba49a90b7e93251383c8d85ad802d3.svg";
export { ForwardRef as ReactComponent };